import { PathlookupIcon } from 'components/Graph/icons/PathlookupIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const PathLookupEmptyContent: FC = () => {
  const msg = useLocale();
  return (
    <>
      <p className='text-bold text-uppercase'>
        <PathlookupIcon
          title={null}
          className='mr-2.5 align-baseline inline'
          variant='coloredDark'
          width='16'
          height='16'
        />
        {msg.canvasGraph.emptyGraph.pathlookup.title}
      </p>
      <p>{msg.canvasGraph.emptyGraph.pathlookup.description}</p>
    </>
  );
};
